<template lang="pug">
v-layout(row)
  v-flex(xs12 sm8 offset-sm2 md6 offset-md3)
    v-list(two-line)
      template(v-for="(report, index) in reports")
        v-list-tile(:key="`report-${report.id}`" avatar ripple @click="show(report)")
          v-list-tile-content
            v-list-tile-title {{ report.reportTheme.title }}
            v-list-tile-sub-title.caption {{ report.updated_at.toString() }}
        v-divider(v-if="index + 1 < reports.length" :key="index")

    .text-xs-center.my-4
      pagination(
        :length="pages"
        v-model="pagination.page"
        :disabled="loading")
</template>

<script>
import { plainToClass } from 'class-transformer'
import Report from '@/models/report'
import Response from '@/utils/response'
import mPageLoading from '@/mixins/page-loading'
import mPageTitle from '@/mixins/page-title'
import mPagination from '@/mixins/pagination'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination
  },
  mixins: [
    mPageLoading,
    mPageTitle,
    mPagination,
  ],
  title () {
    return this.$t("pages.user.reports.index.title")
  },
  props: {
    page: Number,
    repository: Object
  },
  data: () => ({
    reports: [],
    defaultPerPage: 15
  }),
  mounted () {
    if (this.page)
      this.pageChange(this.page)
    else
      this.fetchData()
  },
  watch: {
    'pagination.page': 'pageChange'
  },
  methods: {
    async fetchData (page) {
      if (this.loading) return
      this.loading = true
      try {
        const response = new Response(await this.repository.index({ params: this.pageParams }))
        this.reports = plainToClass(Report, response.result)
        this.pagination.totalCount = response.pageInfo.total_count
      } catch (error) {
        this.$store.commit('setAxiosError', error)
      } finally {
        this.loading = false
      }
    },
    pageChange (num) {
      if (num > 1) this.$router.push({ query: { page: num } })
      this.pagination.page = num
      this.fetchData()
    },
    show (report) {
      this.$router.push({
        name: 'report-show',
        params: { id: report.id },
        query: { from: this.$route.fullPath },
      })
    }
  }
}
</script>
